import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import { GetdatafirebaseService } from '../../services/getdatafirebase.service';

@Component({
  selector: 'app-docmeetfarmer',
  templateUrl: './docmeetfarmer.component.html',
  styleUrls: ['./docmeetfarmer.component.css']
})
export class DocmeetfarmerComponent implements OnInit, OnDestroy {

  userdata:any;
  selectyear:any;
  constructor(private auth:Authenticationservice, private spinner:NgxSpinnerService, private firebase: GetdatafirebaseService) {
    this.userdata = this.auth.Authention();
    this.firebase.getYear().then((year: any) => {this.selectyear = year;});
   }

  ngOnInit(): void {
    this.Loadaction();
    this.goloadfarmerinzone();
    this.Loadsavelist();
  }

  ngOnDestroy(): void {
    this.listaction = null;  
    this.fmplantlist = null;
    this.famerlist = null;
  }

  // บันทึกข้อมูล
  model:any=[];
  onSubmit(formdata:any){
  let data =  (formdata.form.value);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_operation_data_w?itid="+data.landno
    
    +"&year="+data.year[0]
    
    +"&creatBy=" + this.userdata.supcode
    +"&operate1=" + data.activity1
    +"&operate_date1="+  data.activity1Date
    +"&operate2=" +data.activity2
    +"&operate_date2="+  data.activity2Date
    +"&operate3=" +data.activity3
    +"&operate_date3="+  data.activity3Date
    +"&operate4=" +data.activity4
    +"&operate_date4="+  data.activity4Date
    +"&operate5=" +data.activity5
    +"&operate_date5="+  data.activity5Date;
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0]==1){
        alert('บันทึกข้อมูลแล้ว');
        this.Loadsavelist();
      }
      else {
        alert('!!! เกิดข้อผิดพลาดบันทึกข้อมูลไม่สำเร็จ!!! ');
      }
     }).catch( err => {  throw err })
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57 )) {
      return false;
    }
    return true;
  }

  // โหลดข้อมูลแปลงชาวไร่
  fmplantlist:any;
  LoadOnefarmerdata(){
    this.fmplantlist = null;
    let year = this.model.year;
    let fmcode = this.model.fmcode;
    if (fmcode == '')
    { alert('เลือกหรือระบุรหัสชาวไร่');}
    else {
      this.spinner.show();
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp_data_w?year="+year[0]+"&fmcode="+ fmcode;
    axios.get(url)
    .then(res => {
      if(res.data.rowsAffected[0]==0){
        alert('ไม่มีข้อมูลแปลง ใน' + year[1] +' หรือลองค้นหาใหม่');
      }
      else {
      this.fmplantlist = res.data.recordset;
      console.log(this.fmplantlist);
      }
      this.spinner.hide();
    }).catch(err => {console.log(err);})
    this.spinner.hide();
    }
  }


  // โหลดกิจกรรม
  listaction:any;
  Loadaction(){
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_operation')
    .then(res => {
     this.listaction =  res.data.recordset;
    }).catch( err => {  throw err })
  }

  // โหลดข้อมูลชาวไร่
  famerlist:any;
  goloadfarmerinzone(){
    this.spinner.show();
    let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?supzone="+this.userdata.zonedata;
    axios.get(url)
    .then(res => {
      this.famerlist = res.data.recordset;
    }).catch(err => {console.log(err);})
    this.spinner.hide();
  }
  

  myenterlist:any;
  mydatatable:any;
  @ViewChild('table', {static:false}) table:any;
  Loadsavelist(){
    if  (this.mydatatable != undefined)
    {this.mydatatable.destroy();}
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_operation_data_w?supzone="+this.userdata.zonedata;
    axios.get(url)
    .then(res => {
      this.myenterlist = res.data.recordset;
      setTimeout(() => {
        this.mydatatable = $(this.table.nativeElement).DataTable();
        // this.mydatatable.draw();
        }, 1500);
    }).catch(err => {throw (err);})
  }

}
